import React from 'react';
import { useTranslation } from 'react-i18next';

import PoiPreviewView from './PoiPreviewView';
import { usePointsOfInterestsPreview } from './hooks';

const PoiPreview = () => {
  const { t: translate } = useTranslation();
  const { component, handleClick, poiName } = usePointsOfInterestsPreview();
  if (!component) {
    return null;
  }

  return (
    <PoiPreviewView
      onClick={handleClick}
      poiName={poiName || translate('poiPreview.pointOfInterest')}
    >
      {component}
    </PoiPreviewView>
  );
};

export default PoiPreview;
